import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import deepmerge from 'deepmerge';
import { DraggableElements, DraggableListConfiguration, ElementDroppedEvent } from './drag-and-drop-lists.model';

@Component({
  selector: 'miq-drag-and-drop-lists',
  templateUrl: './drag-and-drop-lists.component.html',
  styleUrls: ['./drag-and-drop-lists.component.scss'],
  standalone: false,
})
export class DragAndDropListsComponent {
  /** Array of draggable lists to render */
  @Input() set draggableLists(lists: DraggableListConfiguration[]) {
    if (lists != null) {
      this._draggableLists = deepmerge([], lists);
      this.runSortingFunctions();
    }
  }
  /** Emits when user picks and drops any element */
  @Output() elementDropped = new EventEmitter<ElementDroppedEvent>();
  _draggableLists: DraggableListConfiguration[];

  /**
   * Applies logic to move dragged element in the same list or to another list.
   * It also sorts the elements using custom configuration
   */
  onElementDrop(event: CdkDragDrop<DraggableElements[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.runSortingFunctions();
    this.elementDropped.emit(this.generateDroppedEvent());
  }

  private runSortingFunctions(): void {
    this._draggableLists.forEach(list => {
      const { sorting = null, elements = null } = list || {};
      if (sorting != null && sorting.fn != null) {
        list.elements = sorting.fn(elements);
      }
    });
  }

  private generateDroppedEvent(): ElementDroppedEvent {
    return this._draggableLists.reduce((acc, { id, elements }) => ({ ...acc, [id]: elements }), {});
  }
}
